module.exports = __webpack_public_path__ + "img/logo.10eeab8f.png";